import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { ComcastCapabilitiesExtension } from 'tag/ts/tag/player/adapters/avia/extensions/capabilities/html5/ComcastCapabilitiesExtension';
import { LgCapabilitiesExtension } from 'tag/ts/tag/player/adapters/avia/extensions/capabilities/html5/LgCapabilitiesExtension';
import { SamsungCapabilitiesExtension } from 'tag/ts/tag/player/adapters/avia/extensions/capabilities/html5/SamsungCapabilitiesExtension';
import { XboxCapabilitiesExtension } from 'tag/ts/tag/player/adapters/avia/extensions/capabilities/html5/XboxCapabilitiesExtension';
import { HdcpCapabilitiesExtension } from 'tag/ts/tag/player/adapters/avia/extensions/capabilities/utility/HdcpCapabilitiesExtension';
export class AviaExtensionsManager extends AbstractTagClass {
    get #allExtensions() {
        return [
            ...this.#capabilitiesExtensions
        ];
    }
    get #capabilitiesExtensions() {
        return [
            new LgCapabilitiesExtension({ tag: this?.tag }),
            new XboxCapabilitiesExtension({ tag: this?.tag }),
            new SamsungCapabilitiesExtension({ tag: this?.tag }),
            new ComcastCapabilitiesExtension({ tag: this?.tag }),
            new HdcpCapabilitiesExtension({ tag: this?.tag })
        ];
    }
    get #debugging() {
        if (!this.runtimeVO?.debug?.on) {
            return {};
        }
        return {
            forceAllExtensionsToLoad: false
        };
    }
    constructor(argument) {
        super({
            ...argument,
            name: 'Avia Extensions Manager'
        });
    }
    loadCapabilitiesExtensions() {
        return this.#registerExtensions(this.#capabilitiesExtensions);
    }
    loadAllExtensions() {
        return this.#registerExtensions(this.#allExtensions);
    }
    #registerExtensions(roster) {
        const extensionsLoading = roster
            .filter((extension) => {
            const extensionShouldLoad = extension.shouldBeUsed() || this.#debugging?.forceAllExtensionsToLoad;
            if (!extensionShouldLoad) {
                this?.logger?.log('Extension', extension.name, ' will not be loaded');
            }
            return extensionShouldLoad;
        })
            .map((extension) => {
            return extension.register();
        });
        this?.logger?.log('registerExtensions', 'extensionsLoading', extensionsLoading);
        return Promise.all(extensionsLoading).then((results) => {
            this?.logger?.log('Extension loading complete.', results);
            return true;
        }, (reason) => {
            this?.logger?.warn('Extension loading failed, rejection reason:', reason);
            return false;
        });
    }
}
